import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Alert,
  Box,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";

function ExisitingPoliciesForm({
  classes: { containerButton, formGroup },
  currentAvivaProposals = [],
  errorMessage = {},
  errors,
  existingAvivaPolicies = [],
  existingOtherPolicies = [],
  existingPolicies = [],
  form = {},
  handleChange,
  isFormSubmitted,
  isButtonDisabled,
  modal,
  onSubmit,
  orderDetails = null,
  policyPremium,
  touched,
}) {
  return (
    <Box
      p={1}
      sx={{
        maxHeight: 540, // or any height you prefer
        overflowY: "auto",
      }}
    >
      <Box direction="column">
        <Box>
          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
          >
            <CardContent sx={{ p: 1 }}>
              {/* <Box className={formGroup} textAlign={"left"}>
                <Typography variant="caption">
                  <strong>Customer's Existing Policies</strong>
                </Typography>
              </Box> */}

              <Box className={formGroup} textAlign={"left"} pb={0}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Proposal Number:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      {orderDetails?.proposalno}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"} pb={0}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Customer Status:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="success">
                      {orderDetails?.dedupes_status == 1 ? "EXISTING" : "NEW"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>

        <Box mt={2}>
          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
          >
            <CardContent sx={{ p: 0, pt: 1 }}>
              <Box className={formGroup} textAlign={"left"} pl={1}>
                <Typography variant="caption">
                  <strong>Aviva Existing Policies</strong>
                </Typography>
              </Box>

              {!existingAvivaPolicies.length && (
                <Box>
                  <Typography variant="caption">Not Available</Typography>
                </Box>
              )}

              {existingAvivaPolicies.length > 0 && (
                <>
                  {orderDetails?.dedupes_status == 1 && (
                    <>
                      <Box
                        className={formGroup}
                        textAlign={"left"}
                        pt={0}
                        pb={0}
                        pl={1}
                      >
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={6}
                            variant="subtitle1"
                            textAlign={"left"}
                          >
                            <Typography variant="caption">
                              Total APE:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="success">
                              ₹
                              {new Intl.NumberFormat("en-IN").format(
                                orderDetails?.dedupe_ape
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>

                      <Box className={formGroup} textAlign={"left"} pl={1}>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={6}
                            variant="subtitle1"
                            textAlign={"left"}
                          >
                            <Typography variant="caption">
                              Total FTASA:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="success">
                              ₹
                              {new Intl.NumberFormat("en-IN").format(
                                orderDetails?.dedupes_sum_assured
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  )}

                  <TableContainer
                    component={Paper}
                    sx={{ border: "1px solid #e0e0e06b", borderRadius: "4px" }}
                  >
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              padding: "8px 8px",
                              width: "40%",
                            }}
                          >
                            <Typography variant="caption">
                              <strong>Policy No.</strong>
                            </Typography>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              padding: "8px 8px",
                            }}
                          >
                            <Typography variant="caption">
                              <strong>Annual Premium</strong>
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {existingAvivaPolicies.map((item) => (
                          <TableRow
                            key={item.name}
                            sx={{
                              border: "1px solid #e0e0e06b",
                              borderRadius: "4px",
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              align="left"
                              sx={{
                                padding: "8px 8px",
                                width: "40%",
                              }}
                            >
                              <Typography variant="caption">
                                {item.policyNo}
                              </Typography>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "8px 8px",
                              }}
                            >
                              {item?.annual_premium_custom && (
                                <Typography variant="caption">
                                  {item.annual_premium_custom}
                                </Typography>
                              )}
                              {!item?.annual_premium_custom && (
                                <>
                                  <TextField
                                    type="number"
                                    id="standard-basic"
                                    variant="outlined"
                                    value={policyPremium[item.policyNo]}
                                    name="annualIncome"
                                    onChange={(event) =>
                                      handleChange(event, item)
                                    }
                                    autoComplete="off"
                                    style={{ width: "100%" }}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: 48, // set desired height
                                      },
                                      "& input": {
                                        paddingY: 1.2, // control padding inside
                                      },
                                    }}
                                  />

                                  {touched[item.policyNo] &&
                                    Number(policyPremium[item.policyNo] || 0) <
                                      1000 && (
                                      <Typography
                                        variant="caption"
                                        className="error-message"
                                      >
                                        <small className="text-danger">
                                          Minimum value is ₹1,000
                                        </small>
                                      </Typography>
                                    )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </CardContent>
          </Card>
        </Box>

        <Box mt={2}>
          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
            mt={2}
          >
            <CardContent sx={{ p: 0, pt: 1 }}>
              <Box className={formGroup} textAlign={"left"} pl={1}>
                <Typography variant="caption">
                  <strong>Other Companies Policies</strong>
                </Typography>
              </Box>

              {!existingOtherPolicies.length && (
                <Box>
                  <Typography variant="caption">Not Available</Typography>
                </Box>
              )}

              {existingOtherPolicies.length > 0 && (
                <TableContainer
                  component={Paper}
                  sx={{ border: "1px solid #e0e0e06b", borderRadius: "4px" }}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        sx={{
                          border: "1px solid #e0e0e06b",
                          borderRadius: "4px",
                        }}
                      >
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px 8px",
                            width: "40%",
                          }}
                        >
                          <Typography variant="caption">
                            <strong>Policy No.</strong>
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px 8px",
                          }}
                        >
                          <Typography variant="caption">
                            <strong>Annual Premium</strong>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {existingOtherPolicies.map((item) => (
                        <TableRow
                          key={item.name}
                          sx={{
                            border: "1px solid #e0e0e06b",
                            borderRadius: "4px",
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px 8px",
                              width: "40%",
                            }}
                          >
                            <Typography variant="caption">
                              {item.policyNo}
                            </Typography>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              padding: "8px 8px",
                            }}
                          >
                            {item?.annual_premium_custom && (
                              <Typography variant="caption">
                                ₹{item.annual_premium_custom}
                              </Typography>
                            )}
                            {!item?.annual_premium_custom && (
                              <>
                                <TextField
                                  type="number"
                                  id="standard-basic"
                                  variant="outlined"
                                  value={policyPremium[item.policyNo]}
                                  name="annualIncome"
                                  onChange={(event) =>
                                    handleChange(event, item)
                                  }
                                  autoComplete="off"
                                  style={{ width: "100%" }}
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 48, // set desired height
                                    },
                                    "& input": {
                                      paddingY: 1.2, // control padding inside
                                    },
                                  }}
                                />
                                {touched[item.policyNo] &&
                                  Number(policyPremium[item.policyNo] || 0) <
                                    1000 && (
                                    <Typography
                                      variant="caption"
                                      className="error-message"
                                    >
                                      <small className="text-danger">
                                        Minimum value is ₹1,000
                                      </small>
                                    </Typography>
                                  )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>

        <Box mt={2}>
          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
            mt={2}
          >
            <CardContent sx={{ p: 0, pt: 1 }}>
              <Box className={formGroup} textAlign={"left"} pl={1}>
                <Typography variant="caption">
                  <strong>Currently Applied Proposal</strong>
                </Typography>
              </Box>

              {!currentAvivaProposals.length && (
                <Box>
                  <Typography variant="caption">Not Available</Typography>
                </Box>
              )}

              {currentAvivaProposals.length > 0 && (
                <TableContainer
                  component={Paper}
                  sx={{ border: "1px solid #e0e0e06b", borderRadius: "4px" }}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px 8px",
                            width: "40%",
                          }}
                        >
                          <Typography variant="caption">
                            <strong>Proposal No.</strong>
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px 8px",
                          }}
                        >
                          <Typography variant="caption">
                            <strong>Annual Premium</strong>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {currentAvivaProposals.map((item) => (
                        <TableRow
                          key={item.name}
                          sx={{
                            border: "1px solid #e0e0e06b",
                            borderRadius: "4px",
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px 8px",
                              width: "40%",
                            }}
                          >
                            <Typography variant="caption">
                              {item.policyNo}
                            </Typography>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              padding: "8px 8px",
                            }}
                          >
                            <Typography variant="caption">
                              ₹
                              {new Intl.NumberFormat("en-IN").format(
                                item.annual_premium_custom
                              )}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>
      </Box>

      <ErrorMessage errors={errors} modal={modal} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        <>
          <Box mt={1}>
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={isButtonDisabled}
              isFormSubmitted={isFormSubmitted}
              text={"Proceed"}
              handleClick={onSubmit}
            />
          </Box>
        </>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  ExisitingPoliciesForm
);
